import { useCallback, useEffect, useState } from "react";
import ActivityTableDisplay from "../components/ActivityTableDisplay";
import socket from "../../socket";
import { getUser } from "../../auth"

const URL = process.env.REACT_APP_API_URL;

export default function ActivityTable({ filters, showCheckbox, checkboxLabel, selectedActivities, setSelectedActivities, setVisibleActivities }) {
  const [groupedActivities, setGroupedActivities] = useState({});

  const fetchActivities = useCallback(() => {
    const user = getUser();
    fetch(`${URL}/api/activity/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      }
    })
      .then((res) => res.json())
      .then((activities) => {
        const filtered = activities.filter((activity) => {
          const matchesSearch =
            !filters.search ||
            (activity.title &&
              activity.title.toLowerCase().includes(filters.search.toLowerCase()));

          const matchesOperation =
            !filters.operation || activity.operation === filters.operation;

          const activityDate = new Date(activity.date);

          let matchesDate = true;
          if (filters.dateFilter) {
            const today = new Date();
            let dateLimit = new Date();

            switch (filters.dateFilter) {
              case "hoy":
                matchesDate =
                  activityDate.toDateString() === today.toDateString();
                break;
              case "ayer":
                dateLimit.setDate(today.getDate() - 1);
                matchesDate =
                  activityDate.toDateString() === dateLimit.toDateString();
                break;
              case "semana":
                dateLimit.setDate(today.getDate() - 7);
                matchesDate = activityDate >= dateLimit;
                break;
              case "15dias":
                dateLimit.setDate(today.getDate() - 15);
                matchesDate = activityDate >= dateLimit;
                break;
              case "mes":
                dateLimit.setMonth(today.getMonth() - 1);
                matchesDate = activityDate >= dateLimit;
                break;
              case "año":
                dateLimit.setFullYear(today.getFullYear() - 1);
                matchesDate = activityDate >= dateLimit;
                break;
              default:
                break;
            }
          }

          return (
            matchesSearch &&
            matchesOperation &&
            matchesDate
          );
        });

        setVisibleActivities(filtered)
        const grouped = filtered.reduce((acc, activity) => {
          const fecha = new Date(activity.date);
          const dataKey = fecha.toLocaleDateString("es-AR"); // muestra dd/mm/aaaa
          if (!acc[dataKey]) acc[dataKey] = [];
          acc[dataKey].push(activity);
          return acc;
        }, {})

        setGroupedActivities(grouped);
      })
  }, [filters, setVisibleActivities]);

  useEffect(() => {
    fetchActivities();

    socket.on("actividad_creada", () => {
      console.log("Se creo una nueva actividad");
      fetchActivities()
    });

    socket.on("actividad_borrada", () => {
      console.log("Se borro una actividad");
      fetchActivities()
    })

    socket.on("actividad_editada", () => {
      console.log("Se editó una actividad");
      fetchActivities()
    })

    socket.on("cierre_diario", () => {
      console.log("Se realizó el cierre diario");
      fetchActivities()
    });

    return () => {
      socket.off("actividad_creada");
      socket.off("actividad_borrada");
      socket.off("actividad_editada");
      socket.off("cierre_diario")
    };
  }, [fetchActivities]);

  return (
    <ActivityTableDisplay
      groupedActivities={groupedActivities}
      showCheckbox={showCheckbox}
      checkboxLabel={checkboxLabel}
      selectedActivities={selectedActivities}
      setSelectedActivities={setSelectedActivities}
    />
  );
}
